/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingQuotaDefinition
 */
export interface BillingQuotaDefinition {
    /**
     * 
     * @type {number}
     * @memberof BillingQuotaDefinition
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof BillingQuotaDefinition
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BillingQuotaDefinition
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof BillingQuotaDefinition
     */
    lookupKey: BillingQuotaDefinitionLookupKeyEnum;
    /**
     * 
     * @type {number}
     * @memberof BillingQuotaDefinition
     */
    defaultValue: number;
}

/**
* @export
* @enum {string}
*/
export enum BillingQuotaDefinitionLookupKeyEnum {
    EmployeeHardLimit = 'employee_hard_limit',
    EmployeeMessageLimitDaily = 'employee_message_limit_daily',
    EmployeeSoftLimit = 'employee_soft_limit',
    InProgressTimesheetEntriesLimit = 'in_progress_timesheet_entries_limit',
    LocationsLimit = 'locations_limit',
    MaxSingleFileBytes = 'max_single_file_bytes',
    MaxTotalFileBytes = 'max_total_file_bytes',
    ShiftAreasLimit = 'shift_areas_limit'
}


/**
 * Check if a given object implements the BillingQuotaDefinition interface.
 */
export function instanceOfBillingQuotaDefinition(value: object): value is BillingQuotaDefinition {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('lookupKey' in value) || value['lookupKey'] === undefined) return false;
    if (!('defaultValue' in value) || value['defaultValue'] === undefined) return false;
    return true;
}

export function BillingQuotaDefinitionFromJSON(json: any): BillingQuotaDefinition {
    return BillingQuotaDefinitionFromJSONTyped(json, false);
}

export function BillingQuotaDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingQuotaDefinition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'lookupKey': json['lookupKey'],
        'defaultValue': json['defaultValue'],
    };
}

  export function BillingQuotaDefinitionToJSON(json: any): BillingQuotaDefinition {
      return BillingQuotaDefinitionToJSONTyped(json, false);
  }

  export function BillingQuotaDefinitionToJSONTyped(value?: BillingQuotaDefinition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'lookupKey': value['lookupKey'],
        'defaultValue': value['defaultValue'],
    };
}

